import { useContext } from "react";
import { styled } from "@mui/material/styles";
import { useMediaQuery, useTheme } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import { useNavigate, useLocation } from "react-router-dom";
import { RestaurantContext } from "src/Utils/Context/RestaurantContext";
import { DRAWER_WIDTH } from "../../Pages/Home/PageRestau";
import SideBarBrand from "./SideBarBrand";
import SideBarRestaurantSelect from "./SideBarRestaurantSelect";
import SideBarNav from "./SideBarNav";
import SideBarUserMenu from "./SideBarUserMenu";

const NON_ID_SEGMENTS = new Set([
  "no-restaurant",
  "restaurant-list",
  "statistics",
  "add-restaurant",
  "admin-dashboard",
  "admin-control-panel",
  "my-organization",
]);

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  backgroundColor: "#fff",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  borderRight: "1px solid #edf2f7",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "#fff",
  overflowX: "hidden",
  width: `calc(${theme.spacing(8)} + 1px)`,
  borderRight: "1px solid #edf2f7",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SideBar({ leftDrawerOpened, setleftDrawerOpened }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const { restaurants } = useContext(RestaurantContext);

  const restaurantId = (() => {
    const parts = location.pathname.split("/");
    const segment = parts[2];
    if (segment && !NON_ID_SEGMENTS.has(segment)) return segment;
    return null;
  })();

  const nav = (path) => () => {
    if (matchDownSM) setleftDrawerOpened(false);
    navigate(path);
  };

  return (
    <Drawer
      anchor="left"
      open={leftDrawerOpened}
      variant="permanent"
      onClose={() => setleftDrawerOpened(false)}
    >
      <SideBarBrand
        leftDrawerOpened={leftDrawerOpened}
        onClose={() => setleftDrawerOpened(false)}
      />
      <Divider
        style={{ backgroundColor: "#edf2f7", height: "1px", width: "100%" }}
      />

      {leftDrawerOpened && restaurants.length > 0 && (
        <>
          <SideBarRestaurantSelect restaurants={restaurants} />
          <Divider
            style={{ backgroundColor: "#edf2f7", height: "1px", width: "100%" }}
          />
        </>
      )}

      <SideBarNav
        leftDrawerOpened={leftDrawerOpened}
        restaurantId={restaurantId}
        pathname={location.pathname}
        nav={nav}
      />

      <SideBarUserMenu leftDrawerOpened={leftDrawerOpened} />
    </Drawer>
  );
}
